export default __webpack_public_path__ + "static/media/equipSword.16dafb14.mp3";